"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var i18n = _interopRequireWildcard(require("I18n"));

var _Auth = _interopRequireDefault(require("./lib/Auth"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

require("redux");

var _reactRedux = require("react-redux");

var _configureStore = _interopRequireDefault(require("./lib/configureStore"));

var _reactRouter = require("react-router");

var _Routes = _interopRequireDefault(require("./Routes"));

var _utils = require("./lib/utils");

var _createHistory = _interopRequireDefault(require("./lib/createHistory"));

var _reactRhumb = require("react-rhumb");

var _rhumbConfig = _interopRequireDefault(require("../rhumb-config.yaml"));

var _historyAdapterV = _interopRequireDefault(require("react-rhumb/historyAdapterV3"));

var _Raven = _interopRequireDefault(require("Raven"));

// Redux
// Configure the router
// Monitoring and Performance
var Application = /*#__PURE__*/function () {
  function Application() {
    (0, _classCallCheck2.default)(this, Application);
  }

  (0, _createClass2.default)(Application, [{
    key: "start",
    // Kicks off the app. This is intentionally not in the constructor just in
    // case there is a reason you need to explictly call init (and don't want it
    // auto-called by importing this module)
    value: function start() {
      var _this = this;

      window.AppInstance = this;
      this.init().then(function () {
        _this.startRedux();

        _this.startRouter();
      }).done();
    } // Performs all the initialization needed before the main app code can run/render.

  }, {
    key: "init",
    value: function init() {
      // Kick off the auth process
      var authenticate = _Auth.default.init();

      authenticate.then(function (_ref) {
        var user = _ref.user;

        _Raven.default.setUserContext({
          id: user.get('user_id'),
          email: user.get('email'),
          locale: user.get('locale')
        });
      }); // Sets hubspot.portal.id (unless `{ preserveGlobalId: true }` was passed)

      _PortalIdParser.default.get(); // Return a promise that is resolved when every promise in Auth initializers
      // and I18n has resolved. AKA, when everything is ready.


      return Promise.all([authenticate, i18n.Info]);
    }
  }, {
    key: "startRedux",
    value: function startRedux() {
      var _auth$get = _Auth.default.get(),
          user = _auth$get.user,
          gates = _auth$get.gates,
          portal = _auth$get.portal;

      var session = new Date().valueOf();
      var initialState = {
        user: user,
        gates: gates,
        portal: portal,
        session: session
      };
      this.store = (0, _configureStore.default)({
        auth: initialState
      });
    }
  }, {
    key: "startRouter",
    value: function startRouter() {
      var history = (0, _createHistory.default)((0, _utils.getRootUrl)());
      (0, _reactDom.render)(_react.default.createElement(_reactRedux.Provider, {
        store: this.store
      }, _react.default.createElement(_reactRhumb.RhumbProvider, {
        history: (0, _historyAdapterV.default)(history),
        config: _rhumbConfig.default
      }, _react.default.createElement(_reactRouter.Router, {
        history: history
      }, _Routes.default))), document.querySelector('#composeUI'));
    }
  }]);
  return Application;
}();

exports.default = Application;
module.exports = exports.default;